var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClosePlayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25511",
    "data-name": "Group 25511",
    transform: "translate(-0.447)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_179",
    "data-name": "Ellipse 179",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(0.447 0)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "_24px-3",
    "data-name": "24px-3",
    transform: "translate(12.108 12.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13597",
    "data-name": "Path 13597",
    d: "M23.768,6.89,21.878,5l-7.494,7.494L6.89,5,5,6.89l7.494,7.494L5,21.878l1.89,1.89,7.494-7.494,7.494,7.494,1.89-1.89-7.494-7.494Z",
    transform: "translate(1.703 1.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13598",
    "data-name": "Path 13598",
    d: "M0,0H32.174V32.174H0Z",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePlayer);
export default __webpack_public_path__ + "static/media/close-player.154ea5a7f30fc8bcabc2e3a047cb0d83.svg";
export { ForwardRef as ReactComponent };